// extracted by mini-css-extract-plugin
export default {"container":"HeaderNav_container__kXCyJ","logo":"HeaderNav_logo__zfwtr"};